<template lang="pug">
.card.market-card(v-if="source['ml'] != null || source['hdp'] != null || source['ou'] != null || source['oe'] != null")
  .card-header.bg-more-head.collapse-more(
    :id="'heading-corner1-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-corner1-' + childId"
    :aria-controls="'collapse-corner1-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-corner1-' + childId"
    :id="'collapse-corner1-' + childId"
  )
    .card-body.p-0
      .market-card-content
        //- small.text-dark {{ source['oxt']  }}
        //- .match(:class="{ 'live' : source.match[4] == 3 }")
        //-   .match-info
        //-     .d-flex.match-info-team
        //-       .match-info-home-name(:class="source.team == 1 ? 'team-red' : 'team-black'")
        //-         .name {{ source.match[5] }}
        //-       TimePanel(:source="source" mode=true)
        //-       .match-info-away-name(:class="source.team == 0 ? 'team-red' : 'team-black'")
        //-         .name {{ source.match[6] }}
        .normal(v-if="source['ml'] || source['hdp'] || source['ou'] || source['oe']")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Home") }}
              template(v-if="source['oxt'] && source['oxt'][0] && source['oxt'][0][5] != 0 && source['oxt'][0][5] != ''")
                OddsItem(:odds="source['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Away") }}
              template(v-if="source['oxt'] && source['oxt'][0] && source['oxt'][0][7] != 0 && source['oxt'][0][7] != ''")
                OddsItem(:odds="source['oxt'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Draw") }}
              template(v-if="source['oxt'] && source['oxt'][0] && source['oxt'][0][6] != 0 && source['oxt'][0][6] != ''")
                OddsItem(:odds="source['oxt'][0]" idx=6 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Odd") }}
              template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][5] != 0 && source['oe'][0][5] != ''")
                OddsItem(:odds="source['oe'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Even") }}
              template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][7] != 0 && source['oe'][0][7] != ''")
                OddsItem(:odds="source['oe'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
          .normal-odd-area
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Home") }}
              p.mb-0 {{ $t("m.ODD_Away") }}
            swiper(ref="swhdp" :options="swiperOptions" @slideChange="handleSlideChangeHDP")
              template(v-for="(dn, i) in source['tn']")
                swiper-slide.normal-odd-area-group
                  template(v-if="source['hdp'] && source['hdp'][i] && source['hdp'][i][9] != 0 && source['hdp'][i][10] != 0 && source['hdp'][i][9] != '' && source['hdp'][i][10] != ''")
                    OddsItem(:odds="source['hdp'][i]" :idx="source['hdp'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="source" homeAway="1" :style="source['tn'] > 4 ? 'width:90px;' : 'width:auto;'")
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['hdp'] && source['hdp'][i] && source['hdp'][i][9] != 0 && source['hdp'][i][10] != 0 && source['hdp'][i][9] != '' && source['hdp'][i][10] != ''")
                    OddsItem(:odds="source['hdp'][i]" :idx="source['hdp'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="source" homeAway="2" :style="source['tn'] > 4 ? 'width:90px;' : 'width:auto;'")
                  template(v-else)
                    OddsDisabled
              swiper-pagination(v-if="source['tn'] > 4" slot="pagination")
          .normal-odd-area
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Over") }}
              p.mb-0 {{ $t("m.ODD_Under") }}
            swiper(ref="swou" :options="swiperOptions" @slideChange="handleSlideChangeOU")
              template(v-for="(dn, i) in source['tn']")
                swiper-slide.normal-odd-area-group
                  template(v-if="source['ou'] && source['ou'][i] && source['ou'][i][11] != 0 && source['ou'][i][12] != 0 && source['ou'][i][11] != '' && source['ou'][i][12] != ''")
                    OddsItem(:odds="source['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" homeAway="1" :details="source" :style="source['tn'] > 4 ? 'width:90px;' : 'width:auto;'") 
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['ou'] && source['ou'][i] && source['ou'][i][11] != 0 && source['ou'][i][12] != 0 && source['ou'][i][11] != '' && source['ou'][i][12] != ''")
                    OddsItem(:odds="source['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="i" homeAway="2" :details="source" :style="source['tn'] > 4 ? 'width:90px;' : 'width:auto;'")
                  template(v-else)
                    OddsDisabled
              swiper-pagination(v-if="source['tn'] > 4" slot="pagination")
          //- .normal-odd-area
          //-   .normal-odd-area-group
          //-     .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_MLF", 2) }}
          //-     template(v-if="source['ml'] && source['ml'][0] && source['ml'][0][5] != 0 && source['ml'][0][5] != ''")
          //-       OddsItem(:odds="source['ml'][0]" idx=5 :typ="oddsType" dataType="2")
          //-     template(v-else)
          //-       OddsDisabled
          //-     template(v-if="source['ml'] && source['ml'][0] && source['ml'][0][7] != 0 && source['ml'][0][7] != ''")
          //-       OddsItem(:odds="source['ml'][0]" idx=7 :typ="oddsType" dataType="2")
          //-     template(v-else)
          //-       OddsDisabled
          //-   .normal-odd-area-group
          //-     .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HDPF", 2) }}
          //-     template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
          //-       OddsItem(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="1")
          //-     template(v-else)
          //-       OddsDisabled
          //-     template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
          //-       OddsItem(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="2")
          //-     template(v-else)
          //-       OddsDisabled
          //-   .normal-odd-area-group
          //-     .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_OUF", 2) }}
          //-     template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
          //-       OddsItem(:odds="source['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count="0" :details="source" homeAway="1")
          //-     template(v-else)
          //-       OddsDisabled
          //-     template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
          //-       OddsItem(:odds="source['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count="0" :details="source" homeAway="2")
          //-     template(v-else)
          //-       OddsDisabled
          //-   .normal-odd-area-group
          //-     .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_OEF", 2) }}
          //-     template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][5] != 0 && source['oe'][0][5] != ''")
          //-       OddsItem(:odds="source['oe'][0]" idx=5 :typ="oddsType" dataType="2")
          //-     template(v-else)
          //-       OddsDisabled
          //-     template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][7] != 0 && source['oe'][0][7] != ''")
          //-       OddsItem(:odds="source['oe'][0]" idx=7 :typ="oddsType" dataType="2")
          //-     template(v-else)
          //-       OddsDisabled
        //- .normal(v-if="source['mlh'] || source['hdph'] || source['ouh'] || source['oeh']")
        //-   .normal-title {{ $t("ui.half_time") }}
        //-   .normal-odd-area
        //-     .normal-odd-area-group
        //-       .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_MLH", 2) }}
        //-       template(v-if="source['mlh'] && source['mlh'][0] && source['mlh'][0][5] != 0 && source['mlh'][0][5] != ''")
        //-         OddsItem(:odds="source['mlh'][0]" idx=5 :typ="oddsType" dataType="2")
        //-       template(v-else)
        //-         OddsDisabled
        //-       template(v-if="source['mlh'] && source['mlh'][0] && source['mlh'][0][7] != 0 && source['mlh'][0][7] != ''")
        //-         OddsItem(:odds="source['mlh'][0]" idx=7 :typ="oddsType" dataType="2")
        //-       template(v-else)
        //-         OddsDisabled
        //-     .normal-odd-area-group
        //-       .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HDPH", 2) }}
        //-       template(v-if="source['hdph'] && source['hdph'][0] && source['hdph'][0][9] != 0 && source['hdph'][0][10] != 0 && source['hdph'][0][9] != '' && source['hdph'][0][10] != ''")
        //-         OddsItem(:odds="source['hdph'][0]" :idx="source['hdph'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdph" count="0" :details="source" homeAway="1")
        //-       template(v-else)
        //-         OddsDisabled
        //-       template(v-if="source['hdph'] && source['hdph'][0] && source['hdph'][0][9] != 0 && source['hdph'][0][10] != 0 && source['hdph'][0][9] != '' && source['hdph'][0][10] != ''")
        //-         OddsItem(:odds="source['hdph'][0]" :idx="source['hdph'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdph" count="0" :details="source" homeAway="2")
        //-       template(v-else)
        //-         OddsDisabled
        //-     .normal-odd-area-group
        //-       .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_OUH", 2) }}
        //-       template(v-if="source['ouh'] && source['ouh'][0] && source['ouh'][0][11] != 0 && source['ouh'][0][12] != 0 && source['ouh'][0][11] != '' && source['ouh'][0][12] != ''")
        //-         OddsItem(:odds="source['ouh'][0]" idx=12 :typ="oddsType" dataType="1" mode="ouh" label="over" count="0" :details="source" homeAway="1")
        //-       template(v-else)
        //-         OddsDisabled
        //-       template(v-if="source['ouh'] && source['ouh'][0] && source['ouh'][0][11] != 0 && source['ouh'][0][12] != 0 && details['ouh'][0][11] != '' && source['ouh'][0][12] != ''")
        //-         OddsItem(:odds="source['ouh'][0]" idx=11 :typ="oddsType" dataType="1" mode="ouh" label="under" count="0" :details="source" homeAway="2")
        //-       template(v-else)
        //-         OddsDisabled
        //-     .normal-odd-area-group
        //-       .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_OEH", 2) }}
        //-       template(v-if="source['oeh'] && source['oeh'][0] && source['oeh'][0][5] != 0 && source['oeh'][0][5] != ''")
        //-         OddsItem(:odds="source['oeh'][0]" idx=5 :typ="oddsType" dataType="2")
        //-       template(v-else)
        //-         OddsDisabled
        //-       template(v-if="source['oeh'] && source['oeh'][0] && source['oeh'][0][7] != 0 && source['oeh'][0][7] != ''")
        //-         OddsItem(:odds="source['oeh'][0]" idx=7 :typ="oddsType" dataType="2")
        //-       template(v-else)
        //-         OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import TimePanel from "@/components/mobile/main/timePanel";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    TimePanel
  },
  mixins: [mixinHDPOUOdds],
  props: {
    childId: {
      type: Number
    },
    mode: {
      type: Number
    },
    sid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndexHDP: 0,
      activeIndexOU: 0,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true,
        observeParents: true
      }
    };
  },
  computed: {
    swiperhdp() {
      return this.$refs.swhdp ? this.$refs.swhdp.$swiper : 0;
    },
    swiperou() {
      return this.$refs.swou ? this.$refs.swou.$swiper : 0;
    },
    leagueName() {
      // var result = "";
      // if([2, 3, 5, 7, 8, 9, 11, 20].includes(this.sid)) {
      //   var result = this.source["league"].split(" - ");
      //   if (result.length >= 2) {
      //     return result[result.length - 1];
      //   }
      //   return this.source["league"];
      // } else {
      //   result = this.source["match"][5];
      //   if (result) {
      //     result = result.split(" ");
      //     return result[result.length - 2] + " " + result[result.length - 1];
      //   } else {
      //     return this.source["league"];
      //   }
      // }

      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        if (result.length - 2 != 0) {
          if (result.length <= 5) {
            return result[result.length - 2] + " - " + result[result.length - 1];
          }
          if (result.length <= 6) {
            return result[result.length - 3] + " - " + result[result.length - 2] + " - " + result[result.length - 1];
          }
        }
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  },
  mounted() {
    this.activeIndexHDP = this.swiperhdp.activeIndex;
    this.activeIndexOU = this.swiperhdp.activeIndex;
  },
  methods: {
    handleSlideChangeHDP() {
      this.activeIndexHDP = this.swiperhdp.activeIndex;
    },
    handleSlideChangeOU() {
      this.activeIndexOU = this.swiperhdp.activeIndex;
    }
  }
}
</script>